import type { SoftphoneProvider } from './softphoneClient.types';

/**
 * Whether a rep has what their carrier needs to place calls. Twilio and Telnyx calls go out from a
 * number we assign the rep (`voiceCallerNumber`); JustCall calls go out from whichever number the
 * rep picks inside JustCall's own dialer, so they need none from us.
 */
export function repCanPlaceCalls(params: {
  voiceProvider: SoftphoneProvider;
  voiceCallerNumber: string | null | undefined;
}): boolean {
  return params.voiceProvider === 'justcall' || Boolean(params.voiceCallerNumber);
}

/**
 * Whether we choose the number a call goes out from — and so whether "Calling from" / the
 * change-number flow / assigning numbers to reps mean anything. Not for JustCall, which picks it in
 * its own dialer. A type guard, so callers can hand the narrowed carrier to number-only UI.
 */
export function carrierUsesOurCallerNumber<P extends SoftphoneProvider>(
  voiceProvider: P,
): voiceProvider is Exclude<P, 'justcall'> {
  return voiceProvider !== 'justcall';
}

/**
 * How often a surface that is warning "every number is at today's call limit" checks again, so the
 * Call button comes back on its own once an admin raises a limit or the rep's day turns over —
 * instead of staying greyed until a reload.
 */
export const CALL_LIMIT_RECHECK_MS = 60_000;
